<template>
  <div>
    <van-popup
      v-model="creates"
      position="right"
      :style="{ height: '100%',width:'100%', background: '#f5f5f5',overflow: 'hidden'}"
    >
      <van-nav-bar fixed>
        <div slot="title">选择学生</div>
        <div slot="right" @click="cancelDate">关闭</div>
      </van-nav-bar>
      <div class="select-people">
        <van-search v-model="searchText" placeholder="请输入学生姓名/校内号" shape="round" @input="onSearch"></van-search>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" style="padding-bottom: 30px;">
          <van-checkbox-group v-model="result">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in list"
                clickable
                v-bind:key="index"
                v-bind:title="`${item.FullName}`"
                @click="toggle(item,index)"
              >
                <!-- <img v-bind:src="$store.state.apiPath + item.Icon" slot="right-icon"/> -->
                <van-checkbox v-bind:name="item" ref="checkboxes" slot="right-icon" />
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-list>
      </div>
      <div class="sigle-bottom-btn">
        <van-button type="info" plain round @click="cancelDate">取消</van-button>
        <van-button type="info" round @click="okDate">确认</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>

export default {
  props: {
    isShowSelectStudent: Boolean
  },
  name: "selectStudent",
  computed: {
    creates: {
      get: function() {
        return this.isShowSelectStudent;
      },
      set: function(ed) {
        this.isModal = ed;
      }
    }
  },
  data() {
    return {
      isModal: false,
      searchText: "",
      studentList: [],
      list: [],
      listTem:[],
      isLoading: false, //下拉刷新状态
      loading: false,
      finished: false,
      result: []
    };
  },
  created() {},
  mounted() {},
  methods: {
    onSearch() {
      this.list = this.listTem
      let newList = []
      this.list.forEach((item) => {
        if(item.FullName.search(this.searchText) !== -1){
          newList.push(item) 
        }
      })
      this.list = newList
      console.log(this.list)
      //this.onLoad();
    },
    // 获取数据
    async onLoad() {
      this.xy.loading();
      this.list = [];
      let res = await this.xyapi.get(
        this.xyMApi + "/xy/comm/GetStudentorganizationMemberByID",
        {
          schoolDistrictID: 0,
          studentGradeID: 0,
          studentGradeForStudentYearID: 0,
          studentOrganizationID: this.$parent.dataCurrent.ID
        }
      );
      if (res.success) {
        this.xy.unloading();
        let _list = res.data[0].Children;
        this.list = [...this.list, ..._list];
        this.listTem = this.list
        this.finished =
          this.list.length >= res.data[0].Children.length ? true : false;
        for (var i = 0; i < this.list.length; i++) {
          this.list[i].isCheckbox = false;
        }
      }
      // 加载状态结束
      this.loading = false;
    },
    // onRefresh() {
    //   setTimeout(() => {
    //     this.list = [];
    //     this.pageIndex = 1;
    //     this.isLoading = false;
    //     // this.onLoad();
    //   }, 500);
    // },
    // 点击选择
    toggle(val, index) {
      this.$refs.checkboxes[index].toggle();
      val.isCheckbox = !val.isCheckbox;
    },

    // 取消选择时间
    cancelDate() {
      this.$emit("SelectStudentClose", false);
    },

    // 点击确定
    okDate() {
      this.studentList = [];
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].isCheckbox) {
          this.studentList.push(this.list[i]);
        }
      }
      console.log(this.studentList);
      console.log(this.studentList.length);
      // 子组件值传入父组件
      this.$emit("SelectStudent", this.studentList);
      this.cancelDate();
    }
  }
};
</script>
<style scoped lang="less">
.select-people {
  position: fixed;
  top: 80px;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f9f9f9 !important;
  z-index: 111;
  overflow: auto;
  .people-list {
    padding: 0 20px;
    overflow: auto;
    .item {
      line-height: 60px;
      font-size: 24px;
      color: #333333;
    }
  }
}
.sigle-bottom-btn {
  height: 110px;
  line-height: 110px;
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 999999 !important ;
  button {
    flex: 0.5;
    margin: 17px 30px;
  }
}
</style>
